import { render, staticRenderFns } from "./ReportTable.vue?vue&type=template&id=021cf4b4&scoped=true&"
import script from "./ReportTable.vue?vue&type=script&lang=ts&"
export * from "./ReportTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReportTable.vue?vue&type=style&index=0&id=021cf4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021cf4b4",
  null
  
)

export default component.exports